import React, { useEffect, useState } from 'react';
import './style.css';
import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as OfferTagIcon } from '../../../../assets/Offers/OfferTag.svg';
import confettiAnimationData from "../../lotties/confetti.json";
import Lottie from 'lottie-react';
import TranslateText from '../../../resuableComponents/TranslateText';
import { setCouponModal, setSuccessModal } from '../../../../slices/OfferSlice';
import { offerInputEnteredEvent, offerInputSelectedEvent } from '../../../../Utils/uiAnalytics';
import { useFieldAnalytics } from '../../../../Utils/useFieldAnalytics';


function CouponInput({
    baseColor,
    handleToggleCoupon,
    appliedCoupon,
    showAppliedCoupon,
    disabled,
    isInModal,
}) {
    const [couponCode, setCouponCode] = useState('');
    const [error, setError] = useState(false);
    const [showConfetti, setShowConfetti] = useState(false)
    const offerApplyLoader = useSelector((state) => state.offers.offerApplyLoader);
    const isCouponApplied = Boolean(appliedCoupon?.code && showAppliedCoupon);
    const isInputDisabled = isCouponApplied || disabled || offerApplyLoader;
    const dispatch = useDispatch()
    const { trackFieldSelected } = useFieldAnalytics();
    // Fires the ENTERED event once, when the field loses focus with a value.
    // `value` only gates whether to fire — it is never sent to the analytics payload.
    const trackFieldEntered = (event, value) => {
        if (value) event();
    };

    const handleChange = (e) => {
        const value = e?.target?.value?.toUpperCase() || '';
        setCouponCode(value);
        setError(false);
    };

    const handleApplyOrRemove = (isRemove = false) => {
        if (isRemove) {
            setCouponCode('');
        }
        if (couponCode) {
            handleToggleCoupon(
                couponCode,
                isRemove,
                () => {
                    if (isInModal) {
                        dispatch(setSuccessModal(true));
                        dispatch(setCouponModal(false));
                    } else {
                        setError(false)
                        if (!isRemove) {
                            setShowConfetti(true)
                            setTimeout(() => {
                                setShowConfetti(false)
                            }, 3000)
                        }
                    }

                },
                () => setError(true)
            );
        }
    };

    useEffect(() => {
        if (showAppliedCoupon) {
            setCouponCode(appliedCoupon?.code || '');
            setError(false);
        } else {
            setCouponCode('');
        }
    }, [appliedCoupon, showAppliedCoupon]);

    return (
        <>
            <div style={{ position: 'relative' }}>
                <div className={`couponInputContainer ${error ? 'errorInput' : ''}`}>
                    {isCouponApplied ? (
                        <div className="appliedCouponText">
                            <OfferTagIcon style={{ color: baseColor, width: '16px', height: '16px' }} />
                            <span className="semiBold14Heading">{appliedCoupon.code}</span>
                            <span className="regular14Heading"> <TranslateText label={"APPLIED_TEXT"}> applied</TranslateText>!</span>
                        </div>
                    ) : (
                        <input
                            value={couponCode}
                            disabled={isInputDisabled}
                            placeholder="Enter Coupon Code"
                            className="couponInput"
                            onChange={handleChange}
                            onFocus={() => trackFieldSelected(offerInputSelectedEvent)}
                            onBlur={() => trackFieldEntered(offerInputEnteredEvent, couponCode)}
                            aria-label="Enter coupon code"
                        />
                    )}

                    {isCouponApplied && (
                        <span onClick={() => handleApplyOrRemove(true)} className="removeButton">
                            <TranslateText label={"REMOVE_COUPON"}>
                                Remove
                            </TranslateText>
                        </span>
                    )}

                    {!isCouponApplied && (
                        <Button
                            onClick={() => handleApplyOrRemove()}
                            loading={(couponCode && offerApplyLoader)}
                            style={{ color: couponCode ? baseColor : '', padding: 0, textTransform: !isCouponApplied ? "uppercase" : "capitalize" }}
                            className={`applyBtn ${couponCode ? 'active' : 'disabled'}`}
                        >
                            <TranslateText label={"APPLY_COUPON"}>
                                APPLY
                            </TranslateText>
                        </Button>
                    )}
                </div>

                {error && <p className="coupon-input-error"><TranslateText label={"INVALID_COUPON_ERROR"}>Coupon code is not valid</TranslateText></p>}
            </div>
            {showConfetti && <div className='confettiContainer' style={{ position: "absolute", top: 0 }}>
                <Lottie
                    animationData={confettiAnimationData}
                    loop={true}
                    autoplay={true}
                    style={{ width: "200px" }}
                    speed={4.5}
                />
            </div>}
        </>
    );
}

export default CouponInput;
